<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.UaTurakina"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.KaikokopuRiverFlow"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.UaKaungaroa"></app-basic-cartesian-chart>
